import React from 'react';
import { publicAPI } from '../lib/api';
import { useSettings } from '../App';
import { useT, useLang, itemHasLocale } from '../lib/i18n';
import { ModernTestimonialsPage } from '../components/ModernListPages';

const API = process.env.REACT_APP_BACKEND_URL;
const resolveSrc = (v) => v ? (v.startsWith('/api') ? `${API}${v}` : v) : null;

// /testimonials (s141) — every testimonial on one page (target of the home
// section's "Read more reviews" link). «Moderno» gets the internal-page
// standard; other themes a plain grid on their own colours.
function DefaultTestimonialsPage() {
  const tt = useT();
  const { lang } = useLang();
  const [items, setItems] = React.useState([]);
  React.useEffect(() => { publicAPI.getTestimonials().then(r => setItems(r.data || [])).catch(() => {}); }, []);
  const list = items.filter(t => t.visible !== false && itemHasLocale(t.content, lang));
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 py-16 pt-24 md:pt-28" data-testid="testimonials-page">
      <h1 className="text-3xl md:text-4xl font-bold text-center mb-14" style={{ fontFamily: 'Playfair Display, serif', color: 'var(--color-heading, #1a2332)' }}>Testimonials</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {list.map(t => (
          <figure key={t.id} className="bg-white rounded-lg p-6 border border-slate-100 shadow-sm flex flex-col gap-4">
            <blockquote className="m-0 italic" style={{ color: 'var(--color-body-text, #475569)' }}>{tt(t.content)}</blockquote>
            <figcaption className="flex items-center gap-3 mt-auto">
              {resolveSrc(t.avatar || t.image) && <img src={resolveSrc(t.avatar || t.image)} alt="" className="w-10 h-10 rounded-full object-cover" />}
              <div>
                <div className="font-semibold text-sm" style={{ color: 'var(--color-heading, #1a2332)' }}>{tt(t.name)}</div>
                {(tt(t.role) || tt(t.company)) && <div className="text-xs" style={{ color: 'var(--color-accent, #0D9488)' }}>{tt(t.role) || tt(t.company)}</div>}
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  );
}

export default function TestimonialsPage() {
  const settings = useSettings();
  return settings.active_theme === 'modern' ? <ModernTestimonialsPage /> : <DefaultTestimonialsPage />;
}
